import React from 'react';
import { Dashboard } from './pages/Dashboard';

export default function DashboardPage() {
	return <Dashboard />;
}
